import "../../Styles/General & MultiUse/Fees.css";
import { useContext, useEffect } from "react";
import ReactDOM from "react-dom";
import ZGA from "../../Assets/ZGA.png";
import { RiCloseLargeLine } from "react-icons/ri";
import { ZGAContext } from "../../ZGAContext";
import { useLocation, useNavigate } from "react-router-dom";
import { ClassesFee } from "../../Assets/Data/ClassesFee";

const Fees = (classData) => {
  const { currentModal, closeModal } = useContext(ZGAContext);
  const navigate = useNavigate();
  const location = useLocation();
  const selectedClassFee = ClassesFee.find((image) => location.pathname === image.url);

  const handleRegisterClick = () => {
    closeModal();
    navigate("/register");
  };

  useEffect(() => {
    const handlePopState = () => {
      if (currentModal === "fees") {
        closeModal();
      }
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [currentModal, closeModal]);

  if (currentModal !== "fees") return null;

  return ReactDOM.createPortal(
    <>
      <div className="backdrop" onClick={closeModal}></div>
      <div className="fees">
        <div>
          <img src={ZGA} alt="The Zulaykha Global Academy" />
          <RiCloseLargeLine onClick={closeModal} />
        </div>
        <h1>Student Fee</h1>
        {selectedClassFee && (
          <img
            src={window.innerWidth > 768 ? selectedClassFee.large : selectedClassFee.small}
            alt={selectedClassFee.name}
            className="fee-image"
          />
        )}
        <button onClick={() => handleRegisterClick()}>Continue to Register</button>
      </div>
    </>,
    document.getElementById("modal-root")
  );
};

export default Fees;
